import React from "react";
import { Modal } from "react-bootstrap";
import FeatherIcon from "feather-icons-react";
import {
  CLAIM_TYPE_CATEGORY,
  getClaimTypeCategoryOptions,
} from "../constants/claimTypeCategory";
import "../css/CaseCategorySelectModal.css";

const categoryMeta = {
  [CLAIM_TYPE_CATEGORY.HEALTH]: {
    icon: "heart",
    description: "Health insurance claims and investigations",
    accent: "#10b759",
    gradient: "linear-gradient(135deg, #ecfdf5 0%, #d1fae5 100%)",
  },
  [CLAIM_TYPE_CATEGORY.MOTOR]: {
    icon: "truck",
    description: "Motor OD claims and field investigations",
    accent: "#3b82f6",
    gradient: "linear-gradient(135deg, #eff6ff 0%, #dbeafe 100%)",
  },
};

const CaseCategorySelectModal = ({ show, onHide, onSelect, title = "Select Case Type" }) => {
  const options = getClaimTypeCategoryOptions();

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="case-category-picker"
      backdropClassName="case-category-picker-backdrop"
      dialogClassName="case-category-picker-modal"
    >
      <Modal.Header closeButton className="border-0 pb-0">
        <Modal.Title className="w-100 text-center pt-2">
          <div style={{ fontSize: "1.15rem", fontWeight: 700 }}>{title}</div>
          <div style={{ fontSize: "0.85rem", color: "#6c757d", fontWeight: 400, marginTop: 4 }}>
            Choose which case category you want to view
          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 pb-4 pt-3">
        <div
          style={{
            display: "grid",
            gridTemplateColumns: options.length > 1 ? "repeat(2, minmax(0, 1fr))" : "1fr",
            gap: "16px",
          }}
        >
          {options.map((option) => {
            const meta = categoryMeta[option.value] || categoryMeta[CLAIM_TYPE_CATEGORY.HEALTH];
            return (
              <button
                key={option.value}
                type="button"
                onClick={() => onSelect(option.value)}
                style={{
                  border: "1px solid #e9ecef",
                  borderRadius: "14px",
                  background: meta.gradient,
                  padding: "24px 16px",
                  textAlign: "center",
                  cursor: "pointer",
                  transition: "transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease",
                  boxShadow: "0 4px 14px rgba(0, 0, 0, 0.06)",
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = "translateY(-3px)";
                  e.currentTarget.style.boxShadow = "0 10px 24px rgba(0, 0, 0, 0.12)";
                  e.currentTarget.style.borderColor = meta.accent;
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = "translateY(0)";
                  e.currentTarget.style.boxShadow = "0 4px 14px rgba(0, 0, 0, 0.06)";
                  e.currentTarget.style.borderColor = "#e9ecef";
                }}
              >
                <div
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: "50%",
                    margin: "0 auto 14px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    background: "#fff",
                    color: meta.accent,
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                  }}
                >
                  <FeatherIcon icon={meta.icon} size={26} />
                </div>
                <div style={{ fontSize: "1.05rem", fontWeight: 700, color: "#212529" }}>
                  {option.label}
                </div>
                <div style={{ fontSize: "0.8rem", color: "#6c757d", marginTop: 6, lineHeight: 1.4 }}>
                  {meta.description}
                </div>
              </button>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default CaseCategorySelectModal;
